import React from 'react';

import { Anchor, FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../models';
import YesAndNo from '../../../Widgets/YesAndNo';
import { ONE_HUNDRED_YEAR_FLOODPLAIN } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function OneHundredYearFloodplain({ section, setSectionValues }: Props): JSX.Element {
  function onYesFloodplainClick(): void {
    setSectionValues({
      [ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN]: true,
    });
  }

  function onNoFloodplainClick(): void {
    setSectionValues({
      [ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN]: false,
    });
  }

  return (
    <>
      <FormField
        required
        label={<Label>Is the property located in a 100-year floodplain?</Label>}
        description={
          <FormHelp>
            <span>
              A 100-year floodplain has a 1% chance of flooding in any given year.{' '}
              <Anchor
                href="https://www.fema.gov/flood-zones"
                target="_blank"
                rel="noopener noreferrer"
                css={{ font: 'inherit' }}
              >
                Learn more
              </Anchor>
            </span>
          </FormHelp>
        }
        control={
          <YesAndNo
            noHandler={onNoFloodplainClick}
            yesHandler={onYesFloodplainClick}
            yesActive={section.getFieldValue(ONE_HUNDRED_YEAR_FLOODPLAIN.FIELD_NAME.LOCATED_IN_100_YEAR_FLOODPLAIN)}
          />
        }
      />
    </>
  );
}

OneHundredYearFloodplain.description = 'Oregon specific flooding screen';
